import { styled } from '@mui/material/styles';
import { MuiIconButton } from '../../../../../modules/material';

export interface StyledUploadContainerProps {
  uploaded?: boolean;
  dragActive?: boolean;
}

export const StyledFlexContainer = styled('div')`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const StyledFileUploadContainer = styled(StyledFlexContainer, {
  shouldForwardProp: (prop: string) =>
    !['uploaded', 'dragActive'].includes(prop),
})<StyledUploadContainerProps>((props) => {
  const { theme, uploaded, dragActive } = props;

  return {
    justifyContent: 'space-between',
    borderRadius: 'var(--payment-component-file-upload-border-radius)',
    padding: '12px 16px',
    border: `1px dashed rgba(${theme.palette.neutral.RGB900}, 0.1)`,
    backgroundColor: theme.palette.neutral[50],

    ...(dragActive && {
      border: `1px dashed ${theme.palette.neutral[800]}`,
    }),

    ...(uploaded && {
      border: `1px solid ${theme.palette.neutral[200]}`,
      backgroundColor: theme.palette.neutral[0],
      boxShadow: '0px 4px 32px 0px rgba(8, 33, 66, 0.05)',
    }),

    ...(!uploaded && { cursor: 'pointer' }),
  };
});

export const StyledRemoveButton = styled(MuiIconButton)((props) => {
  const { theme } = props;

  return {
    color: theme.palette.neutral[600],
    backgroundColor: theme.palette.neutral[0],
  };
});
